import { motion } from "framer-motion";
import { X, CheckCircle2 } from "lucide-react";
import { COMPARISON } from "@/lib/siteData";

export const Differentiator = () => {
  return (
    <section className="relative py-12 lg:py-16 bg-slate-50 overflow-hidden">
      <div className="absolute inset-0 dot-pattern opacity-50" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl"
        >
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-cyan-600">
            Why We're Different
          </span>
          <h2 className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 leading-[1.05]">
            Most Laboratories Give Results.
            <br />
            <span className="water-text">We Provide Answers.</span>
          </h2>
          <p className="mt-5 text-lg text-slate-600 max-w-2xl">
            We combine professional lab analysis with plain-English summaries and real-world treatment expertise — so you actually know what to do next.
          </p>
        </motion.div>

        <div className="mt-14 grid lg:grid-cols-2 gap-6">
          {/* Other Labs */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative rounded-3xl bg-white border border-slate-200 p-8 lg:p-10"
          >
            <div className="flex items-center justify-between mb-6">
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400">
                Other Laboratories
              </span>
              <span className="px-3 py-1 rounded-full bg-slate-100 text-slate-500 text-xs font-semibold">
                Status Quo
              </span>
            </div>
            <div className="space-y-3">
              {COMPARISON.others.map((item) => (
                <div key={item} className="flex items-start gap-3 py-3 border-b border-slate-100 last:border-0">
                  <div className="w-6 h-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0">
                    <X className="w-3.5 h-3.5 text-slate-400" />
                  </div>
                  <span className="text-base text-slate-500 leading-relaxed">{item}</span>
                </div>
              ))}
            </div>
          </motion.div>

          {/* Us */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="relative rounded-3xl bg-slate-900 p-8 lg:p-10 overflow-hidden"
          >
            {/* glow */}
            <div className="absolute -top-20 -right-20 w-72 h-72 bg-cyan-500/25 rounded-full blur-3xl" />
            <div className="absolute -bottom-20 -left-20 w-72 h-72 bg-sky-500/20 rounded-full blur-3xl" />

            <div className="relative">
              <div className="flex items-center justify-between mb-6">
                <span className="text-xs font-bold uppercase tracking-[0.2em] text-cyan-400">
                  Aware Water Testing
                </span>
                <span className="px-3 py-1 rounded-full bg-cyan-500/15 text-cyan-300 text-xs font-semibold border border-cyan-400/20">
                  Our Standard
                </span>
              </div>
              <div className="space-y-3">
                {COMPARISON.us.map((item) => (
                  <div key={item} className="flex items-start gap-3 py-3 border-b border-white/5 last:border-0">
                    <div className="w-6 h-6 rounded-full bg-cyan-500/15 flex items-center justify-center flex-shrink-0">
                      <CheckCircle2 className="w-4 h-4 text-cyan-400" />
                    </div>
                    <span className="text-base text-white/95 leading-relaxed font-medium">{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
